'use strict';

module.exports = {
    initialize() {
        const VALUE_BUSINESS = 'B2B';

        /**
         * Setup accountType by value
         * @param {string} selectedValue Account type selected value 'B2C'/'B2B'
         */
        function accountTypeSetup(selectedValue) {
            const $companynameContainer = $('#companynameContainer');
            const $btwContainer = $('#btwContainer');
            if (selectedValue === VALUE_BUSINESS) {
                $companynameContainer.show();
                $btwContainer.show();
                $companynameContainer
                    .find('#registration-form-company-name')
                    .attr('required', 'required');
                $btwContainer
                    .find('#registration-form-btw')
                    .attr('required', 'required');
                return;
            }
            // Default setup, empty value of 'customer'
            $companynameContainer.hide();
            $btwContainer.hide();
            $companynameContainer
                .find('#registration-form-company-name')
                .removeAttr('required');
            $btwContainer.find('#registration-form-btw').removeAttr('required');
        }

        const accountTypeValue = $(
            '#addressAccountTypeContainer input[type=radio]:checked'
        ).val();
        accountTypeSetup(accountTypeValue);

        $(document).on('change', '#addressAccountTypeContainer input[type=radio]', function () {
            accountTypeSetup(this.value);
        });
    }
};
